export default __webpack_public_path__ + "static/media/Image-5.22e4f236.png";